// export const SERVICE_URL = 'https://checkform.e2w.es/api';
// export const EVENTS_SERVICE_URL = 'wss://checkform.e2w.es/ws';
// export const SERVICE_URL = 'https://ayumar.checkform.es/rest';
// export const EVENTS_SERVICE_URL = 'wss://ayumar.checkform.es/ws';
export const SERVICE_URL = 'http://localhost:6301';
export const EVENTS_SERVICE_URL = 'ws://localhost:7501';
